const whatsIsjurisdictions = "https://academy.clara.co/article/42PuXYiyXmQsXFVzte70L8"

export default [whatsIsjurisdictions];